import type { ExistingVideos } from "./loadPanel.types";

export const existingVideos: ExistingVideos = {
    pl: {
        pl: {
            euro_com_pl: {
                iphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }],
                    backsidetopcorner: [{ type: "video" }],
                    front: [{ type: "video" }],
                    frontbattery: [{ type: "video" }],
                    frontimei: [{ type: "video" }],
                },
                smartphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }], // *** //
                    backsidetopcorner: [{ type: "video" }], // *** //
                    front: [{ type: "video" }], // *** //
                    frontimei: [{ type: "video" }],
                    frontmodel: [{ type: "video" }],
                },
            },
            "euro-test_com_pl": {
                iphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }],
                    backsidetopcorner: [{ type: "video" }],
                    front: [{ type: "video" }],
                    frontbattery: [{ type: "video" }],
                    frontimei: [{ type: "video" }],
                },
                smartphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }], // *** //
                    backsidetopcorner: [{ type: "video" }], // *** //
                    front: [{ type: "video" }], // *** //
                    frontimei: [{ type: "video" }],
                    frontmodel: [{ type: "video" }],
                },
            },
        },
        en: {
            euro_com_pl: {
                iphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }],
                    backsidetopcorner: [{ type: "video" }],
                    front: [{ type: "video" }],
                    frontbattery: [{ type: "video" }],
                    frontimei: [{ type: "video" }],
                },
                smartphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }], // *** //
                    backsidetopcorner: [{ type: "video" }], // *** //
                    front: [{ type: "video" }], // *** //
                    frontimei: [{ type: "video" }],
                    frontmodel: [{ type: "video" }],
                },
            },
            "euro-test_com_pl": {
                iphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }],
                    backsidetopcorner: [{ type: "video" }],
                    front: [{ type: "video" }],
                    frontbattery: [{ type: "video" }],
                    frontimei: [{ type: "video" }],
                },
                smartphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }], // *** //
                    backsidetopcorner: [{ type: "video" }], // *** //
                    front: [{ type: "video" }], // *** //
                    frontimei: [{ type: "video" }],
                    frontmodel: [{ type: "video" }],
                },
            },
        },
    },
};
